import { render, staticRenderFns } from "./StudentsAccountsView.vue?vue&type=template&id=ba688048"
import script from "./StudentsAccountsView.vue?vue&type=script&lang=js"
export * from "./StudentsAccountsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports